"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = useWindowSize;
exports["default"] = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var hasWindow = typeof window !== "undefined";

var getSize = function getSize() {
  return {
    innerHeight: hasWindow ? window.innerHeight : 0,
    innerWidth: hasWindow ? window.innerWidth : 0,
    outerHeight: hasWindow ? window.outerHeight : 0,
    outerWidth: hasWindow ? window.outerWidth : 0
  };
};

function useWindowSize() {
  var ticking = (0, _react.useRef)();

  var _useState = (0, _react.useState)(getSize()),
      _useState2 = _slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  var handleResize = function handleResize() {
    if (!hasWindow) {
      return false;
    }

    if (!ticking.current) {
      window.requestAnimationFrame(function () {
        setWindowSize(getSize());
        ticking.current = false;
      });
      ticking.current = true;
    }

    return true;
  };

  (0, _react.useEffect)(function () {
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowSize;
}

var _default = useWindowSize;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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